import { CatTable } from '@blocks-react/components/Table';
import { CatTableObject } from '@blocks-react/components/TableObject';
import { CVATableProps } from '../types';

export const CVATable = ({ classname, children }: Readonly<CVATableProps>) => {
  return (
    <CatTableObject>
      <CatTable className={classname}>{children}</CatTable>
    </CatTableObject>
  );
};
